import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { usePopover } from '../../../Popovers/redux/hooks';
import { PopoverType } from '../../../Popovers/redux/types';
import { getDeviationNotificationQueue } from '../../../DeviationPage/redux/helpers';
import AddToCollectionPopover from '../../_partials/AddToCollectionPopup';
import FavouriteButton from './FavouriteButton';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
const offsetModifier = [
    0,
    20
];
const FavouriteButtonWithPopover = (props)=>{
    var _popover_params;
    const isMobile = useContext(MobileContext);
    const { actionBarType } = props;
    const { popover, removePopover, togglePopover } = usePopover(actionBarType === 'primary' ? PopoverType.ADD_TO_COLLECTION_PRIMARY : PopoverType.ADD_TO_COLLECTION_SECONDARY);
    const notificationQueue = isMobile ? 'default' : getDeviationNotificationQueue(props.deviation);
    return /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        popoverContent: /*#__PURE__*/ React.createElement(AddToCollectionPopover, {
            isPrivateCollections: false,
            collectibleDeviation: props.deviation,
            notificationQueue: notificationQueue,
            ignorePreselectedCollections: (_popover_params = popover.params) === null || _popover_params === void 0 ? void 0 : _popover_params.ignorePreselectedCollections,
            onClose: removePopover
        }),
        placement: "bottom",
        isVisible: popover.isOpen,
        offsetModifier: offsetModifier,
        onClickOutside: isMobile ? undefined : removePopover
    }, /*#__PURE__*/ React.createElement(FavouriteButton, _object_spread_props(_object_spread({}, props), {
        onArrowClick: togglePopover
    })));
};
FavouriteButtonWithPopover.displayName = 'FavouriteButtonWithPopover';
export default FavouriteButtonWithPopover;
